import React from 'react'

const Paper = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width='50'
    height='50'
    viewBox='0 0 50 50'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M16.6663 37.4998H33.333V33.3332H16.6663V37.4998ZM16.6663 29.1665H33.333V24.9998H16.6663V29.1665ZM12.4997 45.8332C11.3538 45.8332 10.3729 45.4252 9.55697 44.6092C8.74099 43.7932 8.33301 42.8123 8.33301 41.6665V8.33317C8.33301 7.18734 8.74099 6.20643 9.55697 5.39046C10.3729 4.57449 11.3538 4.1665 12.4997 4.1665H29.1663L41.6663 16.6665V41.6665C41.6663 42.8123 41.2584 43.7932 40.4424 44.6092C39.6264 45.4252 38.6455 45.8332 37.4997 45.8332H12.4997ZM27.083 18.7498V8.33317H12.4997V41.6665H37.4997V18.7498H27.083Z'
      fill='currentColor'
    />
  </svg>
)

export default Paper
